var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',_vm._l((_vm.surgeries),function(surgery){return _c('SurgeryListItem',{key:surgery.id,attrs:{"surgery":surgery,"refreshList":_vm.refreshList}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }